import { render } from "./IconPatients.vue?vue&type=template&id=2ced7038"
import script from "./IconPatients.vue?vue&type=script&lang=js"
export * from "./IconPatients.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__